var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lowSource"},[_c('low-source-search'),_c('low-source-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }